/** Keep an exact backend count readable inside the fixed-width rail and dashboard badge. */
export var formatReviewCountBadge = function (count) {
    return (count > 99 ? '99+' : String(count));
};
